<div class="row">
    <div class="col-sm-4">
      <h3 class="sub-title">Task Templates</h3></div>
    <div class="col-sm-8 text-end alert">
      <a [routerLink]="['/task/template/load']" class="btn btn-primary me-2" > <i class="fa fa-plus"> </i> Load Task Template </a>
    </div>
  </div>
<div class="table-responsive" *ngIf="taskTemplates.length>0">
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
    <tr>
    <th>Id</th>
    <th>Edit</th>
    <th>Enabled</th>
    <th>Name</th>
    <th>Modes</th>
    <th>Answer</th>
    <th>Description</th>


    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let taskTemplate of taskTemplates;">
        <td>
            <a [routerLink]="['/task/template/show',taskTemplate.id]">
              {{taskTemplate.id}}
            </a>
        </td>
        <td>
          <a [routerLink]="['/task/template/edit',taskTemplate.id]">
          <i class="fa fa-edit"></i>
          </a>
      </td>
        <td>{{taskTemplate.enabled}}</td>
        <td>{{taskTemplate.name}}</td>
        <td >{{taskTemplate.quizModes}}</td>
        <td >{{taskTemplate.answerTemplateName}}</td>
        <td width="70%">{{taskTemplate.description}}</td>

    </tr>

    </tbody>

</table>
</div>
<app-spinner *ngIf="taskTemplates.length==0"></app-spinner>

